import { BaseController } from '@shared/basecontroller.controller';
import { BankWithdrawalForm } from './bank-withdrawal-form.model';
import { showModal, hideModal } from '@shared/ui/modal.util';
import EVENTS from '@shared/events';

class BankWithdrawalFormController extends BaseController {
  constructor(WithdrawalStore, FormService, PaymentOptionApiService, EventDispatcherService, $timeout, $scope, $state, $translate) {
    'ngInject';

    super();

    this.WithdrawalStore = WithdrawalStore;
    this.FormService = FormService;
    this.PaymentOptionApiService = PaymentOptionApiService;
    this.EventDispatcherService = EventDispatcherService;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.$state = $state;
    this.$translate = $translate;
    this.isClosed = false;

    this.$scope.$on('reload.member-payment-option', () => {
      this.getBankPaymentOptionList();
    });

    this.$scope.$on('reload.bank-sidebar', () => {
      let tempBank = sessionStorage.getItem('temp_bank');
      tempBank = JSON.parse(tempBank);
      if (tempBank) {
        this.form.bankPaymentOptions.push(tempBank);
        this.form.bankPaymentOption = tempBank.id;
        this.onChangeBankAccount();
      }
    });
  }

  $onInit() {
    this.isClosed = true;
    this.addSubscription(this.EventDispatcherService.addListener(EVENTS.MEMBER_PAYMENT_OPTION_CREATED, event => this.getBankPaymentOptionList()));
    this.userCurrency$ = this.WithdrawalStore.getCurrency();
  
    this.form = new BankWithdrawalForm(this.details.customerProducts, this.details.paymentOptions);
    this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
    this.form.paymentOption = this.selectedPaymentOption.id;
    this.form.paymentOptionType = this.selectedPaymentOption.type;
    this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('withdrawal');
    this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('withdrawal');
    this.enableSidebar();
    this.getBankPaymentOptionList();
  }

  getBankPaymentOptionList() {
    this.PaymentOptionApiService.getBankPaymentOption().then((resp) => {
      this.form.bankPaymentOptions = resp;
        angular.forEach(resp, (item) => {
          if (parseInt(item.fields.is_default) === 1) {
            this.form.bankPaymentOption = item.id;
            this.onChangeBankAccount();
          }
        });
    });
  }

  submit() {
    this.FormService.isSubmitting.next(true);
    if (!this.isValidAmount()) {
      $('#errorHeader').html(this.$translate.instant('Opps, amount is not enough!'));
      $('#errorMessage').html(this.$translate.instant('Minimum amount that can be withdrawn is 100 EUR/GBP.'));
      this.FormService.isSubmitting.next(false);
      showModal('invalidBankDetails');
      return false;
    }

    let isChecked = this.form.subTransactions.filter(obj => {
      return obj.chargeFee === true;
    })
    ;

    if (!isChecked.length) {
      showModal('invalidAction');
      this.FormService.isSubmitting.next(false);

      return false;
    }

    if (this.isNotDefault() && !this.form.confirmed) {
      this.confirmDefaultBank();

      return false;
    }

    this.withdraw();
  }

  withdraw() {
    hideModal('bankConfirmationModal');
    $('#bank-modal-backdrop').hide();
    this.WithdrawalStore.withdraw(this.form.toPayload())
      .then(() => {
        this.handleSuccessfulSubmission();
      })
      .catch((errors) => {
        this.form.error.setFormErrors(errors);
        this.FormService.isSubmitting.next(false);
      })
    ;
  }

  setAsDefaultBank() {
    this.form.setAsDefault = true;
    this.form.confirmed = true;
    this.withdraw();
  }

  setAsNotDefaultBank() {
    this.form.setAsDefault = false;
    this.form.confirmed = true;
    this.withdraw();
  }

  confirmDefaultBank() {
    showModal('bankConfirmationModal');
    this.FormService.isSubmitting.next(false);
    $('.modal-backdrop').hide();
    $('#bankSuccessMessage').html(this.$translate.instant('Do you want ') + this.form.bankDetails.fields.bank_name +' ('+ this.form.bankDetails.fields.account_id +') ' + this.$translate.instant('to be your default bank for withdrawal?'));
    $('#bank-modal-backdrop').show();
  }

  isNotDefault() {
    return !this.form.bankDetails.fields.is_default && this.form.bankDetails.is_active;
  }

  onChangeBankAccount() {
    this.PaymentOptionApiService.getPaymentOptionById(this.form.bankPaymentOption).then((resp) => {
      this.form.bankDetails = resp;
      this.form.confirmed = false;
    });
  }

  handleSuccessfulSubmission() {
    this.FormService.isSubmitting.next(false);
    this.form.clearError();
    this.form.props.readOnly = true;
    this.onSuccessfulSubmission({form: this.form, viewDetails: this.paymentOptionsViewDetails});
  }

  resetForm() {
    this.form.reset();
  }

  removeSubTransaction(subTransaction, index) {
    this.form.removeSubTransaction(subTransaction, index);
  }

  formatAmount(subTransaction) {
    return subTransaction.amount = parseFloat(subTransaction.amount);
  }

  isValid() {
    let count = 0;
    angular.forEach(this.form.bankDetails, function (value, key) {
      if (value === null || value === '') {
        count ++;
      }
    });

    return count === 0;
  }

  isValidAmount() {
    let total = this.form.totalAmountToBeWithdrawn;

    return total >= 100;
  }

  enableSidebar() {
    this.$timeout(() => {
      $(".bank-sidebar-wrap .fa-receipt").click(function(e){
        e.preventDefault();
        $(".bank-sidebar-wrap").toggleClass('active');
      });
    }, 500);
  }

  get displayDeleteButton() {
    return this.form.subTransactions.length > 1;
  }
}

export default BankWithdrawalFormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/component/form/bank/bank-withdrawal-form.controller.js